import React, { useState, useEffect, useRef } from 'react';
import { Form, Button,Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Eye,ArrowLeftCircle } from "react-bootstrap-icons";
import AxiosInstance from '../AxiosInstance';
import ToastNotification from '../ToastNotification';
import Layout from './Layout';

const EditCompanyProfile = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('employeeId');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const [formData, setFormData] = useState({
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  about: '',
  website: '',
  image_profile: '',
  building_no: '',
  landmark: '',
  locality: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  });

  const toastRef = useRef();

  useEffect(() => {
    AxiosInstance.get(`/common/api/user-details/${userId}`)
      .then((res) => {
        const data = res.data;
        let website = '';

        if (data.social_media_links) {
          try {
            const parsed = JSON.parse(data.social_media_links);
            const websiteLink = parsed.find((link) => link.platform === 'website');
            website = websiteLink?.url || '';
          } catch (e) {
           toastRef.current?.showToast("Error parsing links",'danger');
          }
        }

        const sanitize = (value) => {
          return value && value !== 'Not provided' ? value : '';
        };
        setFormData({
          first_name: sanitize(data.first_name),
          last_name: sanitize(data.last_name),
          email: sanitize(data.email),
          phone_number: sanitize(data.phone_number),
          about: sanitize(data.about),
          website,
          image_profile: sanitize(data.image_profile),
          building_no: sanitize(data.permanent_building_no),
          landmark: sanitize(data.permanent_landmark),
          locality: sanitize(data.permanent_locality),
          city: sanitize(data.permanent_city),
          state: sanitize(data.permanent_state),
          country: sanitize(data.permanent_country),
          pincode: sanitize(data.permanent_pincode),
        });
      })
      .catch((err) => {
        const msg = err.response?.data?.error || "Failed to load data.";
        toastRef.current?.showToast(msg, 'danger');
      });
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const data = new FormData();
    data.append('first_name', formData.first_name);
    data.append('last_name', formData.last_name);
    data.append('email', formData.email);
    data.append('permanent_building_no', formData.building_no);
    data.append('permanent_landmark', formData.landmark);
    data.append('permanent_locality', formData.locality);
    data.append('permanent_city', formData.city);
    data.append('permanent_state', formData.state);
    data.append('permanent_country', formData.country);
    data.append('permanent_pincode', formData.pincode);
    data.append('phone_number', formData.phone_number);
    data.append('about', formData.about);
    data.append('website', formData.website);
    if (imageFile) {
      data.append('image_profile', imageFile);
    }

    await AxiosInstance.put(`/admin/company-profile/update/${userId}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    toastRef.current?.showToast("Profile updated successfully", 'success');
    setTimeout(() => {
      navigate('/AdminProfile');
    }, 1500);

  } catch (err) {
    const msg = err.response?.data?.error || "Update failed.";
    toastRef.current?.showToast(msg, 'danger');
  }
};


  return (
    <Layout heading="Edit Profile">
        <div className="mb-3">
            <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
            </Button>
        </div>
      <div className="container mt-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <Form.Control name="first_name" value={formData.first_name} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control name="last_name" value={formData.last_name} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control name="email" value={formData.email} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Building No.</Form.Label>
            <Form.Control name="building_no" value={formData.building_no} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Landmark</Form.Label>
            <Form.Control name="landmark" value={formData.landmark} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Locality</Form.Label>
            <Form.Control name="locality" value={formData.locality} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <Form.Control name="city" value={formData.city} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>State</Form.Label>
            <Form.Control name="state" value={formData.state} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Country</Form.Label>
            <Form.Control name="country" value={formData.country} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Pincode</Form.Label>
            <Form.Control name="pincode" value={formData.pincode} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control name="phone_number" value={formData.phone_number} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>About</Form.Label>
            <Form.Control as="textarea" name="about" rows={3} value={formData.about} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Website</Form.Label>
            <Form.Control name="website" value={formData.website} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
          <Form.Label>Profile Image</Form.Label>
          <div className="d-flex align-items-center gap-2">
            <Form.Control 
              type="file" 
              accept="image/*" 
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setImageFile(file);
                  setImagePreview(URL.createObjectURL(file));
                }
              }} 
            />
            {imagePreview && (
              <Button 
                variant="outline-secondary" 
                onClick={() => setShowPreview(true)}
                title="Preview Image"
              >
                <Eye />
              </Button>
            )}
          </div>
        </Form.Group>

        {/* Modal Preview */}
        <Modal show={showPreview} onHide={() => setShowPreview(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Profile Image Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img 
              src={imagePreview} 
              alt="Preview" 
              style={{ width: '150px', height: '150px', borderRadius: '50%' }} 
            />
          </Modal.Body>
          </Modal>
          <Button type="submit" variant="primary">Save Changes</Button>
        </Form>
      </div>
      <ToastNotification ref={toastRef} />
    </Layout>
  );
};

export default EditCompanyProfile;
